/**
 * @generated SignedSource<<547f27509ffb5f2a423fb9c1dfe4317b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type LoginFormQuery$variables = {
  jwt: string;
};
export type LoginFormQuery$data = {
  readonly usersOnAnAccount: ReadonlyArray<{
    readonly avatarURL: string;
    readonly id: string;
    readonly name: string | null;
    readonly username: string;
    readonly usernameID: string;
  }>;
};
export type LoginFormQuery = {
  response: LoginFormQuery$data;
  variables: LoginFormQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "jwt"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "jwt",
        "variableName": "jwt"
      }
    ],
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "usersOnAnAccount",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "usernameID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "avatarURL",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LoginFormQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LoginFormQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "41bb8c74bf1dd73b50e48978835ba798",
    "id": null,
    "metadata": {},
    "name": "LoginFormQuery",
    "operationKind": "query",
    "text": "query LoginFormQuery(\n  $jwt: String!\n) {\n  usersOnAnAccount(jwt: $jwt) {\n    id\n    name\n    username\n    usernameID\n    avatarURL\n  }\n}\n"
  }
};
})();

(node as any).hash = "ff4085e1956cee18d5f5ba7b868e49f7";

export default node;
